import React from 'react'

const DaysSpentIcon = () => {
    return (
        <svg
            style={{ width: '100%' }}
            // width="24" height="24"
            viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M1 12.0001C1 5.92492 5.92492 1 12.0001 1C18.0753 1 23.0002 5.92492 23.0002 12.0001C23.0002 18.0753 18.0753 23.0002 12.0001 23.0002C5.92492 23.0002 1 18.0753 1 12.0001ZM12.764 7.90708C12.764 7.48323 12.4204 7.13963 11.9965 7.13963C11.5727 7.13963 11.2291 7.48323 11.2291 7.90708V11.7263C11.2291 12.154 11.4428 12.5534 11.7987 12.7906L14.6406 14.6852C14.9933 14.9203 15.4698 14.8251 15.7049 14.4724C15.94 14.1197 15.8447 13.6432 15.492 13.4081L12.764 11.5894V7.90708Z" fill="#75FB8E" />
        </svg>

    )
}

export default DaysSpentIcon